import { useImpersonation } from '../contexts/ImpersonationContext';

const PRESET_LABELS: Record<string, string> = {
  setup_help: 'Setup help',
  insights_walkthrough: 'Insights walkthrough',
  bug_investigation: 'Bug investigation',
  other: 'Other',
};

export const ImpersonationBanner = () => {
  const imp = useImpersonation();
  if (!imp.active) return null;

  const reasonLabel = imp.reasonText && imp.reasonText.trim().length > 0
    ? imp.reasonText
    : (imp.reasonPreset ? PRESET_LABELS[imp.reasonPreset] ?? imp.reasonPreset : '');

  return (
    <div
      role="status"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100%',
        padding: '8px 16px',
        background: '#fde047',
        color: '#232730',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        borderBottom: '2px solid #ca8a04',
      }}
    >
      <strong>Impersonating</strong>
      <span>{imp.tenantName ?? ''}</span>
      <span style={{ opacity: 0.7 }}>· Reason: {reasonLabel}</span>
      <button
        type="button"
        onClick={imp.end}
        style={{
          marginLeft: 'auto',
          padding: '4px 12px',
          background: '#232730',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 600,
        }}
      >
        End impersonation
      </button>
    </div>
  );
};
